module.exports = __webpack_public_path__ + "/images/logo-shopee.708f249.webp";